/*
|--------------------------------------------------------------------------
| Utilities: Fetch
|--------------------------------------------------------------------------
*/
/**
 * Fetch utilities
 * @memberof utilities
 * @namespace utilities.fetch
 * @inner
 */
__gh__webApp.utilities.fetch = {
	
	/**
	 * Initialize
	 *
	 * @memberof utilities.fetch
	 * @method init
	 */
	"init": function(){
		this.html.init();
		this.view.init();
	}
};